export var RouletteOptionsClasses;
(function (RouletteOptionsClasses) {
    RouletteOptionsClasses["STRAIGHT"] = "STRAIGHT";
    RouletteOptionsClasses["SPLIT"] = "SPLIT";
    RouletteOptionsClasses["STREET"] = "STREET";
    RouletteOptionsClasses["SQUARE"] = "SQUARE";
    RouletteOptionsClasses["FIVE"] = "FIVE";
    RouletteOptionsClasses["DOUBLE_STREET"] = "DOUBLE_STREET";
    RouletteOptionsClasses["COLUMN"] = "COLUMN";
    RouletteOptionsClasses["EVEN"] = "EVEN";
    RouletteOptionsClasses["ODD"] = "ODD";
    RouletteOptionsClasses["BLACK"] = "BLACK";
    RouletteOptionsClasses["RED"] = "RED";
    RouletteOptionsClasses["LOW"] = "LOW";
    RouletteOptionsClasses["HIGH"] = "HIGH";
    RouletteOptionsClasses["DOZEN"] = "DOZEN";
})(RouletteOptionsClasses || (RouletteOptionsClasses = {}));
